import { handleApiError, handleApiResponse } from "@/methods/api";
import ApiVerified from "@/services/apiVerified";
import {
  OfflineTestSubjectwiseReportDisplay,
  OfflineTestSubjectwiseReportInputs,
} from "@/types/admin";
import { ApiResponse } from "@/types/global";

export default class AdminApi extends ApiVerified {
  async submitOfflineTestSubjectWiseReport(
    reportInputs: OfflineTestSubjectwiseReportInputs,
  ): Promise<ApiResponse> {
    try {
      const response = await this.axiosInstance.post<boolean>(
        `pdf-report/submit-offline-test-subject-wise-report`,
        reportInputs,
      );
      return handleApiResponse(response);
    } catch (error) {
      return handleApiError(error);
    }
  }

  async updateOfflineTestSubjectWiseReportCsv(
    mongoId: string,
    csvFile: string,
  ): Promise<ApiResponse> {
    try {
      const response = await this.axiosInstance.put<boolean>(
        `pdf-report/update-offline-test-subject-wise-report-csv`,
        { mongoId: mongoId, csvFile: csvFile },
      );
      return handleApiResponse(response);
    } catch (error) {
      return handleApiError(error);
    }
  }

  async getAllOfflineTestSubjectWiseReports(
    pageNumber: number,
    pageSize: number,
    batchId: number | null,
    userId: number | null,
  ): Promise<ApiResponse> {
    try {
      const response = await this.axiosInstance.get<Array<OfflineTestSubjectwiseReportDisplay>>(
        `pdf-report/get-all-offline-test-subject-wise-reports`,
        {
          params: { batchId: batchId, userId: userId, pageNumber: pageNumber, pageSize: pageSize },
        },
      );
      return handleApiResponse(response, true);
    } catch (error) {
      return handleApiError(error);
    }
  }
}
